import { createMuiTheme } from '@material-ui/core/styles'
import lightBlue from '@material-ui/core/colors/lightBlue'

export const theme = createMuiTheme({
  palette: {
    primary: { light: "#1CC4E8", main: "#2CB2DC", dark: lightBlue[700] },
    secondary: { light: lightBlue[300], main: lightBlue[500], dark: lightBlue[700] },
  },
})



// WEBPACK FOOTER //
// ./src/config/muiThemeConfig.js